import { render, staticRenderFns } from "./questionBank_info_list_set_type_6.vue?vue&type=template&id=36778490&scoped=true"
import script from "./questionBank_info_list_set_type_6.vue?vue&type=script&lang=js"
export * from "./questionBank_info_list_set_type_6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36778490",
  null
  
)

export default component.exports